import React from 'react'
import Sidebar from './../AdminComponents/Sidebar'
import { Outlet } from 'react-router-dom'
const Admin = () => {
  return (
    <div>
      {/* <Outlet/> */}
      <Sidebar />
    </div>
  )
}

export default Admin